// eslint-disable-next-line no-unused-vars
import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Home from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import Register from '../pages/RegisterPage';
import ForgotPass from '../pages/ForgotPassPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import Download from '../pages/DownloadPage';
import Ranking from '../pages/RankingPage';
import Wiki from '../pages/WikiPage';
import Privacy from '../pages/PrivacyPage';
import Terms from '../pages/TermsPage';
import Refund from '../pages/RefundPage';
import Error from '../pages/ErrorPage';
import SupportPage from '../pages/SupportPage';

import DashboardPage from '../pages/DashboardPage';
import SettingsPage from '../pages/SettingsPage';
import AdminPanel from '../pages/AdminPanel';
import ShopPage from '../pages/ShopPage';
import VotePage from '../pages/VotePage';
import PurchasePage from '../pages/PurchasePage';
import RewardPage from '../pages/RewardPage';

import PaymentSuccess from '../pages/PaymentSuccess';

import useTitle from '../hooks/useTitle';

const PrivateRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  // 🔥 Check, ob der User eingeloggt ist & die richtige Berechtigung hat
  if (!user || (requiredPermission && user.permission !== requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};




const AppRoutes = () => {
  useTitle('Arcane');

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="register" element={<Register />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="forgot-password" element={<ForgotPass />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="download" element={<Download />} />
      <Route path="ranking" element={<Ranking />} />
      <Route path="wiki" element={<Wiki />} />
      <Route path="privacy-policy" element={<Privacy />} />
      <Route path="terms-of-service" element={<Terms />} />
      <Route path="refund-policy" element={<Refund />} />
      <Route path="support" element={<SupportPage />} />
      <Route path="payment-success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
      <Route path="dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
      <Route path="vote" element={<PrivateRoute><VotePage /></PrivateRoute>} />
      <Route path="shop" element={<PrivateRoute><ShopPage /></PrivateRoute>} />
      <Route path="purchase" element={<PrivateRoute><PurchasePage /></PrivateRoute>} />
      <Route path="reward" element={<PrivateRoute><RewardPage /></PrivateRoute>} />
      <Route path="admin" element={<PrivateRoute requiredPermission={3}><AdminPanel /></PrivateRoute>} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

export default AppRoutes;
